<template>
  <div class="basic-model-exchange">
    <transition name="fade-modal">
      <div class="modal-bg"></div>
    </transition>
    <transition name="content-fade">
      <div class="common-wrap">
        <div class="container">
          <div
            v-if="data.type"
            class="header"
            :style="{
              backgroundImage:
                'url(' +
                (data.type === 'success' ? successIcon : alertIcon) +
                ')',
            }"
          ></div>
          <div v-if="data.title" class="title">{{ data.title }}</div>
          <div v-if="data.content" class="content">{{ data.content }}</div>
          <div v-if="data.type !== 'success'" class="btn-wrapper">
            <div class="left-btn confirm-btn" @click="close">不兑换</div>
            <div class="right-btn confirm-btn" @click="confirm">确定兑换</div>
          </div>
          <div v-else class="btn-success" @click="toGuidePage">上课指引</div>
        </div>
        <div class="close" @click="close"></div>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { Vue, Prop, Component } from 'vue-property-decorator';
import Alert from '../assets/alert.svg';
import Success from '../assets/success.svg';
@Component({})
export default class BasicModelExchange extends Vue {
  @Prop({ type: Object, required: true }) data!: object;
  type = 'succes';
  successIcon: string = Success;
  alertIcon: string = Alert;

  close() {
    this.$emit('close', false);
  }
  confirm() {
    this.$emit('confirm');
  }
  toGuidePage() {
    window.location.href =
      'https://www.pypypy.cn/python-class-fos/mobile/1#/guide';
  }
}
</script>

<style lang="scss" scoped>
.modal-bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  min-height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
}
.basic-model-exchange {
  font-family: 'PingFang SC';
  .common-wrap {
    position: fixed;
    top: 0;
    left: 50%;
    z-index: 10000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100vh;
    transform: translateX(-50%);
    .container {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 600px;
      min-height: 594px;
      padding: 0 48px;
      background-color: #ffffff;
      border-radius: 16px;
      box-shadow: 0 2px 10px 0 rgba(56, 35, 219, 0.07);
      .header {
        width: 251px;
        height: 251px;
        margin-top: -125px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .title {
        margin: 17px auto 31px;
        color: #31285d;
        font-weight: bold;
        font-size: 40px;
      }
      .content {
        margin: 0 8px;
        color: #31285d;
        font-size: 32px;
        opacity: 0.5;
      }
      .btn-wrapper {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin: 75px 0 68px;
        .confirm-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 240px;
          height: 86px;
          font-weight: bold;
          font-size: 36px;
          border-radius: 43px;
          user-select: none;
        }
        .left-btn {
          color: #6741ef;
          background-color: #f2eefe;
        }
        .right-btn {
          color: #ffffff;
          background-color: #6741ef;
        }
      }

      .btn-success {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 374px;
        height: 86px;
        margin: 120px 0 68px;
        color: #ffffff;
        font-weight: bold;
        font-size: 36px;
        background-color: #6741ef;
        border-radius: 43px;
        user-select: none;
      }
    }
  }
  .close {
    // position: absolute;
    // bottom: 200px;
    width: 84px;
    height: 84px;
    margin-top: 80px;
    background: url('../assets/close-large.svg') no-repeat center/100%;
  }
}
</style>